module.exports = __webpack_public_path__ + "static/media/EricssonHilda-Regular.41c1b042.otf";